import MedicalRecords from './MedicalRecords';

export default MedicalRecords;
